import { getDocument, getDocuments } from './firestoreService';
import { sortDocumentsByDateDesc } from './documentSort';

export const fetchPatientData = async (patientId, setPatientData, setPatientDocuments) => {
    try {
        const patientData = await getDocument(`patients`, patientId);

        if (patientData) {
            let documents = await getDocuments(`patients/${patientId}/documents`);
            documents = sortDocumentsByDateDesc(documents);

            if (setPatientData) {
                setPatientData(patientData);
            }

            if (setPatientDocuments) {
                setPatientDocuments(documents);
            }

            return { patientData, patientDocuments: documents };
        } else {
            console.error('No such patient!');
            return null;
        }
    } catch (error) {
        console.error('Error fetching patient data:', error);
        return null;
    }
};
